import { render, staticRenderFns } from "./PrintDownload.vue?vue&type=template&id=bcefcf50&scoped=true&"
import script from "./PrintDownload.vue?vue&type=script&lang=js&"
export * from "./PrintDownload.vue?vue&type=script&lang=js&"
import style0 from "./PrintDownload.vue?vue&type=style&index=0&id=bcefcf50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcefcf50",
  null
  
)

export default component.exports